import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="request-route"
        path="/request/:id?"
        component={Page} />
];

export default Routes;